import React, { useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "./common/Button";
import SocialMediaRow from "./common/SocialMediaRow";
import { usePopup } from "./PopupContext";
import { useLocation } from "react-router-dom";
import { addScrollRef, scrollToRef } from "../backend/scrollToRef";
import { getMainInfoByName } from "../backend/info/mainInfo";
import formatPhoneNumber from "../utils/formatNumber";

const Footer = () => {
  const isSingle = useMediaQuery({ query: "(max-width: 1100px)" });
  const isMedium = useMediaQuery({ query: "(max-width: 600px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isSmall = useMediaQuery({ query: "(max-width: 450px)" });

  const { show } = usePopup();
  const contactsRef = useRef(null);
  useEffect(() => {
    addScrollRef("contacts", contactsRef);
  }, [contactsRef]);

  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo === "contacts") {
      window.history.replaceState(null, "", window.location.href);
      scrollToRef(contactsRef);
    }
  }, [location]);
  return (
    <footer
      style={{ ...styles.footerWrapper, paddingTop: isSingle ? "2rem" : "3rem" }}
      ref={contactsRef}
    >
      <div style={{ ...styles.footerContainer, paddingTop: isSingle ? "0rem" : "2rem" }}>
        <div style={{ ...styles.topRow, flexDirection: isSingle ? "column" : "row" }}>
          <div
            style={{
              ...styles.leftColumn,
              alignItems: "flex-start",
            }}
          >
            <img
              src={"/assets/icons/logo-full-wb.svg"}
              style={{
                maxHeight: isSingle ? "clamp(4rem, 13vw, 8rem)" : "9rem",
                marginBottom: isSingle ? "1.5rem" : "6rem",
                justifySelf: "flex-start",
                display: "flex",
                flex: "0 0",
                flexDirection: "row",
              }}
              alt="Логотип"
            />
            <p style={styles.contactTitle}>
              <span style={{ fontWeight: "bold" }}>Відділення рекрутингу</span>
              <br />
              Запитай про наявні вакансіі
            </p>
            <a
              href={formatPhoneNumber(getMainInfoByName("recruitmentPhone"))}
              style={styles.contactText}
            >
              {getMainInfoByName("recruitmentPhone")}
            </a>
            <p style={styles.contactTitle}>
              <span style={{ fontWeight: "bold" }}>Служба ЦВС</span>
              <br />
              Залиш відгук та пропозиції
            </p>
            <a href={formatPhoneNumber(getMainInfoByName("cvsPhone"))} style={styles.contactText}>
              {getMainInfoByName("cvsPhone")}
            </a>
            {!isMobile && (
              <Button
                text={"ПАТРОНАТНА СЛУЖБА"}
                internal_link={"/patronat"}
                border="2px solid var(--white)"
                hoverBorder="2px solid var(--orange)"
                textColor="var(--white)"
                hoverTextColor="var(--orange)"
                fontWeight="normal"
                fontSize="min(1.875rem, 5vw)"
                lineHeight="6rem"
                padding="0rem 2rem"
                alignSelf="center"
                marginLeft="0"
                marginTop="0"
                marginBottom="1rem"
                height="min(20vw, 5rem)"
                width="100%"
              />
            )}
            <p style={styles.contactTitle}>
              <span style={{ fontWeight: "bold" }}>Пресслужба</span>
              <br />
              Надішли запит про співпрацю
            </p>
            <a href={"mailto:" + getMainInfoByName("pressEmail")} style={styles.contactText}>
              {getMainInfoByName("pressEmail")}
            </a>
            {isSingle && (
              <hr style={{ ...styles.divider, margin: "0rem", marginBottom: "0.5rem" }} />
            )}
            <SocialMediaRow
              rowStyle={{
                marginBottom: isSingle ? "" : "1rem",
                marginTop: isSingle ? "" : "1rem",
                position: "relative",
                left: isSingle ? "" : "-30px",
                width: "var(--main-container-width)",
                justifyContent: isSingle ? "space-between" : "start",
              }}
              useFooter={true}
              size={"min(6rem, 18vw)"}
              gap={isSingle ? "0rem" : "2rem"}
            />
          </div>
          {isSingle && (
            <hr style={{ ...styles.divider, marginTop: "1rem", marginBottom: "2rem" }} />
          )}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
            <div
              style={{ ...styles.rightColumn, gap: isSmall ? "2rem" : isMedium ? "2rem" : "3rem" }}
            >
              <Button
                text={"АНОНІМНИЙ ВІДГУК"}
                onClick={() => {
                  show(false);
                }}
                textColor="var(--black)"
                hoverTextColor="var(--black)"
                backgroundColor="var(--orange)"
                hoverBackgroundColor="var(--white)"
                fontWeight="normal"
                fontSize={isSingle ? "min(1.875rem, 5vw)" : "1.875rem"}
                lineHeight="6rem"
                padding="0rem 0.5rem"
                alignSelf="center"
                marginLeft="0"
                marginTop="0"
                marginBottom="0"
                height="min(20vw, 5rem)"
                containerProps={{ width: isSingle ? "" : "21rem" }}
              />
              <div
                style={{
                  ...styles.feedbackContainer,
                  marginTop: isSingle ? "-0.5rem" : "-1rem",
                  marginBottom: isSingle ? "1rem" : "1rem",
                  alignItems: isSingle ? "center" : "flex-end",
                }}
              >
                <p
                  style={{
                    ...styles.feedbackText,
                    position: "absolute",
                    textAlign: isSingle ? "center" : "right",
                    width: isSingle ? "var(--main-container-width)" : "",
                  }}
                >
                  Ви можете залишити анонімний відгук
                  {isSmall ? " " : <br />}
                  про діяльність полку і його посадових осіб
                </p>
              </div>
              <Button
                text={"МЕРЧ"}
                internal_link={"/shop"}
                border="2px solid var(--orange)"
                hoverBorder="2px solid var(--white)"
                textColor="var(--orange)"
                hoverTextColor="var(--white)"
                backgroundColor="var(--black)"
                hoverBackgroundColor="var(--black)"
                fontWeight="normal"
                fontSize="min(1.87rem, 4.9vw)"
                lineHeight="6rem"
                padding="0rem 2rem"
                alignSelf="center"
                marginLeft="0"
                marginTop="0"
                marginBottom="0"
                height="min(20vw, 5rem)"
                width="100%"
              />
              <Button
                text={"АНКЕТА НА ВСТУП"}
                external_link={getMainInfoByName("anketaLink")}
                border="2px solid var(--orange)"
                hoverBorder="2px solid var(--white)"
                textColor="var(--orange)"
                hoverTextColor="var(--white)"
                backgroundColor="var(--black)"
                hoverBackgroundColor="var(--black)"
                fontWeight="normal"
                fontSize="min(1.87rem, 4.9vw)"
                lineHeight="6rem"
                padding="0rem 2rem"
                alignSelf="center"
                marginLeft="0"
                marginTop="0"
                marginBottom="0"
                height="min(20vw, 5rem)"
                width="100%"
              />
              <Button
                text={"ПІДТРИМАТИ"}
                external_link={getMainInfoByName("supportLink")}
                border="2px solid var(--orange)"
                hoverBorder="2px solid var(--white)"
                textColor="var(--orange)"
                hoverTextColor="var(--white)"
                backgroundColor="var(--black)"
                hoverBackgroundColor="var(--black)"
                fontWeight="normal"
                fontSize="min(1.87rem, 4.9vw)"
                lineHeight="6rem"
                padding="0rem 2rem"
                alignSelf="center"
                marginLeft="0"
                marginTop="0"
                marginBottom="0"
                height="min(20vw, 5rem)"
                width="100%"
              />
            </div>
          </div>
        </div>

        <hr style={styles.divider} />
        <div
          style={{
            ...styles.bottomRow,
            flexDirection: isSingle ? "column" : "row",
            gap: isSingle ? "2rem" : "3rem",
          }}
        >
          <p
            style={{
              ...styles.policyText,
              fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              order: isSingle ? "1" : "0",
            }}
          >
            © {new Date().getFullYear()} 210polk.mil.gov.ua
          </p>
          <div
            style={{
              ...styles.policyLinks,
              flexDirection: isSingle ? "column" : "row",
              gap: isSingle ? "2rem" : "2rem",
              order: isSingle ? "0" : "1",
            }}
          >
            <a
              href="/cookie-policy"
              style={{
                ...styles.policyText,
                fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              }}
              onMouseOver={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = isSingle ? "0%" : "100%";
              }}
              onMouseOut={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = "0%";
              }}
            >
              Cookie policy
              <span style={styles.policyUnderline} />
            </a>
            <a
              href="/privacy-policy"
              style={{
                ...styles.policyText,
                fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              }}
              onMouseOver={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = isSingle ? "0%" : "100%";
              }}
              onMouseOut={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = "0%";
              }}
            >
              Політика конфіденційності
              <span style={styles.policyUnderline} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

const styles: Record<string, React.CSSProperties> = {
  footerWrapper: {
    width: "100%",
    color: "var(--white)",
    paddingTop: "3rem",
    display: "flex",
    justifyContent: "center",
    background: 'url("/assets/landing/foot.avif") no-repeat center center',
    backgroundSize: "cover",
  },
  footerContainer: {
    width: "var(--main-container-width)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingBottom: "2rem",
  },
  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    minWidth: "250px",
  },
  rightColumn: {
    display: "inline-flex",
    flexDirection: "column",
    gap: "3rem",
  },
  contactTitle: {
    color: "var(--white)",
    fontSize: "1.125rem",
  },
  contactText: {
    color: "var(--white)",
    fontSize: "min(7vw, 2.5rem)",
    fontWeight: "bold",
    marginBottom: "1rem",
    textDecoration: "none",
  },
  feedbackContainer: {
    display: "flex",
    flexDirection: "column",
    height: "3rem",
  },
  feedbackText: {
    color: "var(--white)",
    fontSize: "min(1.25rem, 5vw)",
    textAlign: "right",
  },
  divider: {
    width: "100%",
    height: "1.5px",
    borderColor: "var(--orange)",
    margin: "2rem 0",
  },
  bottomRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "1rem",
    // alignItems: "center",
  },
  policyLinks: {
    display: "flex",
    // alignItems: "center",
    gap: "2rem",
  },
  policyText: {
    display: "flex",
    flexDirection: "column",
    color: "var(--orange)",
    textDecoration: "none",
    fontSize: "min(1.375rem, 5vw)",
    whiteSpace: "pre",
  },
  policyUnderline: {
    position: "relative",
    bottom: 0,
    left: 0,
    height: "2px",
    width: "0%",
    backgroundColor: "var(--orange)",
    transition: "all 0.3s ease",
  },
};
